export enum UserTable {
    UserData = "UserData",
    UserDetails = "UserDetails"
}